"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DS_IDLE_TIMEOUT_MS = void 0;
const react_1 = require("react");
exports.DS_IDLE_TIMEOUT_MS = 30000;
const INTERACTION_EVENTS = ['mousemove', 'mousedown', 'touchstart', 'keydown', 'wheel'];
const useIdleTimeout = (isActive, onIdle, timeoutMs = exports.DS_IDLE_TIMEOUT_MS) => {
    (0, react_1.useEffect)(() => {
        if (!isActive) {
            return;
        }
        let idleTimeout;
        const resetIdleTimer = () => {
            clearTimeout(idleTimeout);
            idleTimeout = setTimeout(onIdle, timeoutMs);
        };
        INTERACTION_EVENTS.forEach(eventName => {
            window.addEventListener(eventName, resetIdleTimer, { passive: true });
        });
        resetIdleTimer();
        return () => {
            clearTimeout(idleTimeout);
            INTERACTION_EVENTS.forEach(eventName => {
                window.removeEventListener(eventName, resetIdleTimer);
            });
        };
    }, [isActive, onIdle, timeoutMs]);
};
exports.default = useIdleTimeout;
